import { Component, OnInit } from '@angular/core'
import {
  Report,
  ReportCategory,
  DataPageOfReport,
  ReportCategoryDto,
} from '../../../../api/models'
import { ReportsService } from '../../../../api/services'
import { MessageService, ConfirmationService, LazyLoadEvent, SortEvent } from 'primeng/api'
import { UntypedFormBuilder, FormControl } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { Customsort } from '../../../directives/customsort'
import { BehaviorSubject, Observable, map, of } from 'rxjs'

@Component({
  selector: 'app-report',
  templateUrl: './list-reports.component.html',
  styleUrls: ['./list-reports.component.css'],
})
export class ListReportComponent implements OnInit {
    reportCategoryList: Array<ReportCategoryDto>
    cols: { field: string; header: string }[]
    reports: Observable<Report[]> = of([]);

  selectedReport: Report
  showRecords: boolean = false
  update: boolean
  selectedReportCategory: any
  reportOperation: string
  rows: number
  reportForm

  currentPage: number = 1
  first: number = 0 // Variable to track the first record

    reports$ = new BehaviorSubject<DataPageOfReport>(null);
  constructor(
    private fb: UntypedFormBuilder,
    private reportservice: ReportsService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private router: Router,
      private activatedRoute: ActivatedRoute,
      private customsort: Customsort,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: 'reportDisplayName', header: 'Report Display Name' },
      { field: 'reportFileName', header: 'Report File Name' },
      { field: 'reportCategoryName', header: 'Report Category' },
        { field: 'patientFlag', header: 'Patient Report' },
        { field: 'reportDsnName', header: 'Report DSN' },
    ]


      this.loadReportCategoryList();

      debugger;
    this.loadReportList(-1, 1, '', '')
  }

  loadReportCategoryList(): void {
    this.reportservice.reportsGetAllReportCategories({}).subscribe((result) => {
      this.reportCategoryList = result
    })
  }

  loadReportList(
    reportCategoryId: number,
    pageNumber: number,
    sortcolumn: string,
    sortorder: string,
  ): void {
    this.reportservice
      .reportsGet({
        pageNumber: pageNumber,
        pageSize: 10,
        reportCategoryId: reportCategoryId,
      })
      .subscribe((result) => {

          this.reports$.next(result)
          this.reports = this.reports$.asObservable().pipe(map(i => i.data));
          this.rows = result.pageSize
        if (result.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }
        // console.log(result);
      })
  }

  searchonId(): void {
      localStorage.setItem('reportcategory', this.selectedReportCategory)


      this.reports = this.reports$.asObservable().pipe(map(i => i.data), map(i => {


          return i.filter(k => k.reportCategoryID == this.selectedReportCategory.reportCategoryId)

      }));
     // this.loadReportList(this.selectedReportCategory.reportCategoryId, 1, '', '')
  }

  onAddReports(): void {
    localStorage.setItem('reportcategory', this.selectedReportCategory)
    this.router.navigate(['administration/add-reports'], {
      queryParams: {
            rcategory_id: this.selectedReportCategory.reportCategoryId,
            rcategory_name: this.selectedReportCategory.reportCategoryName,
      },
      skipLocationChange: true,
    })
  }

  onEditReport(reportId: number): void {
    this.router.navigate(['administration/edit-reports'], {
      queryParams: { report_Id: reportId },
      skipLocationChange: true,
    })
  }

  onParamReport(reportId: number, reportName: string): void {
    this.router.navigate(['administration/reports-param'], {
      queryParams: { report_Id: reportId, report_Name: reportName },
      skipLocationChange: true,
    })
  }

  onDeleteReport(event, reportid: number) {
    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this Report?',
      accept: () => {
        this.deleteReport(reportid)
      },
    })
  }

  deleteReport(reportid) {
    debugger
    this.reportservice
      .reportsDelete({
        id: reportid,
      })
      .subscribe((data) => {
        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          summary: 'Confirmation!',
          detail: 'Report Deleted Successfully',
          life: 5000,
        })

        this.loadReportList(-1, 1, '', '')
      })
  }

  nextPage($event: LazyLoadEvent) {
      debugger


      alert("jjjj");
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
      if (this.selectedReportCategory) {
        this.loadReportList(
            this.selectedReportCategory.reportCategoryId,
          1,
          $event.sortField,
          order,
        )
      } else {
        this.loadReportList(-1, 1, $event.sortField, order)
      }
      //this.currentPage = 1;
    } else {
      if (this.selectedReportCategory) {
        this.loadReportList(
            this.selectedReportCategory.reportCategoryId,
          nextPage,
          $event.sortField,
          order,
        )
      } else {
        this.loadReportList(-1, nextPage, $event.sortField, order)
      }
      //this.currentPage = nextPage;
    }

    this.currentPage = Math.floor($event.first / $event.rows) + 1
  }


   

}
